// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as AppClientsRouteImport } from './routes/_app/clients'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppSubcontractorsRouteImport } from './routes/_app/subcontractors'
import { Route as AppWorksitesRouteImport } from './routes/_app/worksites'
import { Route as InvitationTokenRouteImport } from './routes/invitation.$token'
import { Route as SuiviTokenRouteImport } from './routes/suivi.$token'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppSettingsOrganisationRouteImport } from './routes/_app/settings/organisation'
import { Route as AppSettingsSubscriptionRouteImport } from './routes/_app/settings/subscription'
import { Route as AppSettingsTeamRouteImport } from './routes/_app/settings/team'
import { Route as AppWorksitesWorksiteIdRouteImport } from './routes/_app/worksites_.$worksiteId'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const RegisterRoute = RegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const VerifyEmailRoute = VerifyEmailRouteImport.update({
            id: '/verify-email',path: '/verify-email',getParentRoute: () => rootRouteImport
          })
const AppClientsRoute = AppClientsRouteImport.update({
            id: '/clients',path: '/clients',getParentRoute: () => AppRoute
          })
const AppDashboardRoute = AppDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AppRoute
          })
const AppSettingsRoute = AppSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AppRoute
          })
const AppSubcontractorsRoute = AppSubcontractorsRouteImport.update({
            id: '/subcontractors',path: '/subcontractors',getParentRoute: () => AppRoute
          })
const AppWorksitesRoute = AppWorksitesRouteImport.update({
            id: '/worksites',path: '/worksites',getParentRoute: () => AppRoute
          })
const InvitationTokenRoute = InvitationTokenRouteImport.update({
            id: '/invitation/$token',path: '/invitation/$token',getParentRoute: () => rootRouteImport
          })
const SuiviTokenRoute = SuiviTokenRouteImport.update({
            id: '/suivi/$token',path: '/suivi/$token',getParentRoute: () => rootRouteImport
          })
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppSettingsRoute
          })
const AppSettingsOrganisationRoute = AppSettingsOrganisationRouteImport.update({
            id: '/organisation',path: '/organisation',getParentRoute: () => AppSettingsRoute
          })
const AppSettingsSubscriptionRoute = AppSettingsSubscriptionRouteImport.update({
            id: '/subscription',path: '/subscription',getParentRoute: () => AppSettingsRoute
          })
const AppSettingsTeamRoute = AppSettingsTeamRouteImport.update({
            id: '/team',path: '/team',getParentRoute: () => AppSettingsRoute
          })
const AppWorksitesWorksiteIdRoute = AppWorksitesWorksiteIdRouteImport.update({
            id: '/worksites_/$worksiteId',path: '/worksites/$worksiteId',getParentRoute: () => AppRoute
          })





const AppSettingsRouteChildren = {
  AppSettingsOrganisationRoute: AppSettingsOrganisationRoute,AppSettingsSubscriptionRoute: AppSettingsSubscriptionRoute,AppSettingsTeamRoute: AppSettingsTeamRoute,AppSettingsIndexRoute: AppSettingsIndexRoute
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(AppSettingsRouteChildren)



const AppRouteChildren = {
  AppClientsRoute: AppClientsRoute,AppDashboardRoute: AppDashboardRoute,AppSettingsRoute: AppSettingsRouteWithChildren,AppSubcontractorsRoute: AppSubcontractorsRoute,AppWorksitesRoute: AppWorksitesRoute,AppWorksitesWorksiteIdRoute: AppWorksitesWorksiteIdRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AppRoute: AppRouteWithChildren,ForgotPasswordRoute: ForgotPasswordRoute,LoginRoute: LoginRoute,RegisterRoute: RegisterRoute,ResetPasswordRoute: ResetPasswordRoute,VerifyEmailRoute: VerifyEmailRoute,InvitationTokenRoute: InvitationTokenRoute,SuiviTokenRoute: SuiviTokenRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)